import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import styles from "./styles/Footer.module.css";
import { useTranslation } from "react-i18next";
import { ReactComponent as IconLocation } from "../../assets/location.svg";
import { ReactComponent as IconPhone } from "../../assets/phone.svg";
import { ReactComponent as IconFax } from "../../assets/fax.svg";
import { ReactComponent as IconEnvelope } from "../../assets/envelope.svg";
import { ReactComponent as IconFile } from "../../assets/file.svg";
import { ReactComponent as IconLinkedin } from "../../assets/linkedin.svg";
import { ReactComponent as IconYoutube } from "../../assets/youtube.svg";
import { ReactComponent as IconFacebook } from "../../assets/facebook.svg";
import { ReactComponent as IconTwitter } from "../../assets/twitter.svg";
import { ReactComponent as IconCircle } from "../../assets/circle.svg";
import DataContext from "../../context/DataContext";
import { deleteObjectEmptyProporties } from "../../utils/utils";
/**
 * Footer link
 */

const LINK_ICONS_OBJ = {
    location: IconLocation,
    phone: IconPhone,
    fax: IconFax,
    envelope: IconEnvelope,
    file: IconFile,
    linkedin: IconLinkedin,
    youtube: IconYoutube,
    facebook: IconFacebook,
    twitter: IconTwitter,
    x: IconTwitter,
    "no logo": null,
};

const MediaLink = ({ linkInfo }) => {
    const { t } = useTranslation();
    const IconComponent = LINK_ICONS_OBJ[linkInfo?.icon];

    const { homePath } = useContext(DataContext);
    const main = (
        <div className={`${styles.media_link_main_container} flex-container`}>
            {IconComponent ? (
                <div className={`${styles.media_link_logo_container_comp} `}>
                    <>
                        <IconCircle
                            className={`${styles.icon_background_comp} icon-component`}
                        />
                        <IconComponent
                            className={`${styles.icon_comp} icon-component`}
                        />
                    </>
                </div>
            ) : (
                <></>
            )}
            <div
                className={`${styles.media_link_text_container} v-flex-container`}
            >
                <div className={`${styles.media_link_text}`}>
                    {t(linkInfo?.body_l1)}
                </div>
                {linkInfo?.body_l2 && (
                    <div className={`${styles.media_link_text}`}>
                        {t(linkInfo?.body_l2)}
                    </div>
                )}
            </div>
        </div>
    );
    const getSocialmedia = () => {
        if (
            !(
                linkInfo?.social &&
                typeof linkInfo?.social === "object" &&
                Object.keys(linkInfo?.social).length > 0
            )
        )
            return <></>;

        const rawMediaContent = deleteObjectEmptyProporties(linkInfo?.social);
        const socialMediaContent = Object.entries(rawMediaContent).map(
            ([type, link]) => ({
                type,
                link,
            }),
        );

        return (
            <div
                className={`${styles.social_media_container} ${rawMediaContent.length > 3 ? styles.spread_media_links : ""} flex-container`}
            >
                {socialMediaContent.map((socialLink) => {
                    const IconComponentSocial =
                        LINK_ICONS_OBJ[socialLink?.type];

                    return (
                        <NavLink
                            key={`social-link-${socialLink?.type}`}
                            to={socialLink?.link}
                            className={`${styles.social_media_link}`}
                            target={"_blank"}
                            rel={"noreferrer"}
                            draggable={"false"}
                            aria-label={`${socialLink?.link}`}
                        >
                            <div
                                className={`${styles.social_media_link_logo_container_comp} `}
                            >
                                <>
                                    <IconCircle
                                        className={`${styles.social_icon_background_comp} icon-component`}
                                    />
                                    <IconComponentSocial
                                        className={`${styles.social_icon_comp} icon-component`}
                                    />
                                </>
                            </div>
                        </NavLink>
                    );
                })}
            </div>
        );
    };

    return (
        <>
            {linkInfo?.type === "email" ||
            linkInfo?.type === "phone" ||
            linkInfo?.type === "location" ||
            linkInfo?.type === "link" ||
            linkInfo?.type === "int-link" ? (
                <NavLink
                    to={
                        linkInfo?.type === "email"
                            ? `mailto:${linkInfo?.details}`
                            : linkInfo?.type === "phone"
                              ? `tel:${linkInfo?.details}`
                              : linkInfo?.type === "location"
                                ? // ? `https://www.google.com/maps/search/?api=1&query=${linkInfo?.details}`
                                  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(linkInfo?.details)}`
                                : linkInfo?.type === "int-link"
                                  ? `${homePath}/${linkInfo?.details}`
                                  : linkInfo?.type === "link" &&
                                    `${linkInfo?.details}`
                    }
                    className={`${styles.media_card_link} flex-container`}
                    state={
                        linkInfo?.type === "int-link" ? { fromApp: true } : null
                    }
                    target={linkInfo?.type === "int-link" ? null : "_blank"}
                    rel={linkInfo?.type === "int-link" ? null : "noreferrer"}
                    draggable={"false"}
                    aria-label={
                        linkInfo?.type === "email"
                            ? `email to ${linkInfo?.details}`
                            : linkInfo?.type === "phone"
                              ? `call ${linkInfo?.details}`
                              : linkInfo?.type === "location"
                                ? `location of ${linkInfo?.body_l1}`
                                : (linkInfo?.type === "link" ||
                                      linkInfo?.type === "int-link") &&
                                  `link to ${linkInfo?.body_l1}`
                    }
                >
                    {main}
                </NavLink>
            ) : linkInfo?.type === "blank" ? (
                <div
                    draggable={"false"}
                    className={`${styles.media_card_link} ${styles.static} flex-container`}
                ></div>
            ) : linkInfo?.type === "social-media" ? (
                getSocialmedia()
            ) : (
                <div
                    draggable={"false"}
                    className={`${styles.media_card_link} ${styles.static} flex-container`}
                >
                    {main}
                </div>
            )}
        </>
    );
};

export default MediaLink;
